import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type DecideBoundaryAuthorityProposalMutationVariables = Types.Exact<{
  input: Types.DecideBoundaryAuthorityProposalInput;
}>;


export type DecideBoundaryAuthorityProposalMutation = { __typename?: 'mutation_root', decide_boundary_authority_proposal?: { __typename?: 'DecideBoundaryAuthorityProposalOutput', success: boolean, status?: string | null, boundary_id?: any | null, jurisdiction_id?: any | null, error?: string | null } | null };


export const DecideBoundaryAuthorityProposalDocument = gql`
    mutation decideBoundaryAuthorityProposal($input: DecideBoundaryAuthorityProposalInput!) {
  decide_boundary_authority_proposal(input: $input) {
    success
    status
    boundary_id
    jurisdiction_id
    error
  }
}
    `;
export type DecideBoundaryAuthorityProposalMutationFn = Apollo.MutationFunction<DecideBoundaryAuthorityProposalMutation, DecideBoundaryAuthorityProposalMutationVariables>;

/**
 * __useDecideBoundaryAuthorityProposalMutation__
 *
 * To run a mutation, you first call `useDecideBoundaryAuthorityProposalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDecideBoundaryAuthorityProposalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [decideBoundaryAuthorityProposalMutation, { data, loading, error }] = useDecideBoundaryAuthorityProposalMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDecideBoundaryAuthorityProposalMutation(baseOptions?: Apollo.MutationHookOptions<DecideBoundaryAuthorityProposalMutation, DecideBoundaryAuthorityProposalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DecideBoundaryAuthorityProposalMutation, DecideBoundaryAuthorityProposalMutationVariables>(DecideBoundaryAuthorityProposalDocument, options);
      }
export type DecideBoundaryAuthorityProposalMutationHookResult = ReturnType<typeof useDecideBoundaryAuthorityProposalMutation>;
export type DecideBoundaryAuthorityProposalMutationResult = Apollo.MutationResult<DecideBoundaryAuthorityProposalMutation>;
export type DecideBoundaryAuthorityProposalMutationOptions = Apollo.BaseMutationOptions<DecideBoundaryAuthorityProposalMutation, DecideBoundaryAuthorityProposalMutationVariables>;